import { AgreementTemplate } from './../_models/agreement-template.model';

// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud/models/query-models/query-results.model';
// State
import { AgreementTemplatesState } from '../_reducers/agreement-template.reducers';
import * as fromAgreementTemplate from '../_reducers/agreement-template.reducers';
import { each } from 'lodash-es';

export const selectAgreementTemplatesState =
  createFeatureSelector<AgreementTemplatesState>('agreementTemplates');

export const selectAgreementTemplateById = (agreementTemplateId: number) =>
  createSelector(
    selectAgreementTemplatesState,
    (agreementTemplatesState) => agreementTemplatesState.entities[agreementTemplateId],
  );

export const selectAllAgreementTemplates = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.allAgreementTemplates,
);

export const selectAllCompanyAgreementTemplates = createSelector(
  selectAgreementTemplatesState,
  fromAgreementTemplate.selectAll,
);

export const selectAllAgreementTemplatesIds = createSelector(
  selectAgreementTemplatesState,
  fromAgreementTemplate.selectIds,
);

export const allAgreementTemplatesLoaded = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.isAllAgreementTemplatesLoaded,
);

export const selectAgreementTemplatesPageLoading = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.listLoading,
);

export const selectAgreementTemplatesActionLoading = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.actionsloading,
);

export const selectLastCreatedAgreementTemplateId = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.lastCreatedAgreementTemplateId,
);

export const selectAgreementTemplatesShowInitWaitingMessage = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.showInitWaitingMessage,
);

export const selectAgreementTemplateLatestSuccessfullAction = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.latestSuccessfullAction,
);

export const selectAgreementTemplateError = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => agreementTemplatesState.error,
);

export const selectQueryResult = createSelector(
  selectAgreementTemplatesState,
  (agreementTemplatesState) => {
    const items: AgreementTemplate[] = [];
    each(agreementTemplatesState.ids, (ele) => {
      const index: number = +ele;
      items.push(agreementTemplatesState.entities[index]);
    });
    return new QueryResultsModel(items, agreementTemplatesState.totalCount);
  },
);
